import React from "react";
import "../index.css";
import { Collapse, Button } from "@chakra-ui/react";
import { useState } from "react";

const UnitInfo = ({ unitInfo }) => {
  const [show, setShow] = useState(false);
  const handleToggle = () => setShow(!show);

  return (
    <div className="m-3 p-4 shadow-md rounded border-gray-300 bg-white">
      <p class="text-xl font-extrabold dark:text-white mb-2">Unit Information</p>
      <p style={{ marginBottom: "5px", color: "#656565" }}>
        {unitInfo.unit_code} - {unitInfo.unit_name}
      </p>

      <div className="mb-2">
        <h3 class="text-md font-extrabold dark:text-white mb-0">Overview</h3>
        <Collapse startingHeight={50} in={show}>
          <p className="text-sm" style={{ marginBottom: "5px", color: "#656565" }}>
            {unitInfo.unit_overview}
          </p>
        </Collapse>
        <Button size="xs" onClick={handleToggle} colorScheme="white" variant="outline">
          Show {show ? "Less" : "More"}
        </Button>
      </div>

      <div className="mb-2">
        <h3 class="text-md font-extrabold dark:text-white mb-0">Prerequisite</h3>
        <p className="text-sm" style={{ marginBottom: "5px", color: "#656565" }}>
          {Array.isArray(unitInfo.prerequisites) && unitInfo.prerequisites.length > 0
            ? // going through first dimension AND
              unitInfo.prerequisites.map((prerequisite, idx) => {
                // going through second dimension OR
                let res = "";
                prerequisite.forEach((unit, idx2) => {
                  if (typeof unit !== "string") {
                    let innerRes = "";
                    // going through third dimension
                    unit.forEach((innerUnit, idx3) => {
                      unit.length - 1 !== idx3
                        ? (innerRes = innerRes + `${innerUnit} and `)
                        : (innerRes = innerRes + `${innerUnit}`);
                    });
                    res = res + `(${innerRes})`;
                  } else {
                    prerequisite.length - 1 !== idx2
                      ? (res = res + `${unit} or `)
                      : (res = res + `${unit}`);
                  }
                });
                if (unitInfo.prerequisites.length - 1 !== idx) return `(${res}) and `;
                else return `(${res})`;
              })
            : "None"}
        </p>
      </div>
      <div className="mb-2">
        <h3 class="text-md font-extrabold dark:text-white mb-0">Prohibitions</h3>
        <p className="text-sm" style={{ marginBottom: "5px", color: "#656565" }}>
          {unitInfo.prohibitions !== undefined
            ? // going through first dimension
              // unitInfo.prohibitions.length == [] ?
              unitInfo.prohibitions.map((prohibition, idx) => {
                // going through second dimension OR
                let res = "";
                prohibition.forEach((unit, idx2) => {
                  if (typeof unit !== "string") {
                    let innerRes = "";
                    // going through third dimension
                    unit.forEach((innerUnit, idx3) => {
                      unit.length - 1 !== idx3
                        ? (innerRes = innerRes + `${innerUnit} and `)
                        : (innerRes = innerRes + `${innerUnit}`);
                    });
                    res = res + `(${innerRes})`;
                  } else {
                    prohibition.length - 1 !== idx2
                      ? (res = res + `${unit} or `)
                      : (res = res + `${unit}`);
                  }
                });
                if (unitInfo.prohibitions.length - 1 !== idx) return `(${res}) and `;
                else return `(${res})`;
              })
            : "None"}
        </p>
      </div>
      <div className="mb-2">
        <h3 class="text-md font-extrabold dark:text-white mb-0">Lecturers</h3>
        <p className="text-sm" style={{ marginBottom: "5px", color: "#656565" }}>
          {unitInfo.lecturers !== undefined
            ? unitInfo.lecturers.map((lecturer, idx) => {
                if (unitInfo.lecturers.length - 1 !== idx) return `${lecturer}, `;
                else return lecturer;
              })
            : null}
        </p>
      </div>
    </div>
  );
};

export default UnitInfo;
